import { ProductRepository } from '../repositories/ProductRepository';
import { diContainer, serviceNames } from '../../service-setup/diContainer';

export interface IFavorites {
    skuBaseIds: number[];
}

export class FavoritesLoadedUseCase {
    private productRepository: ProductRepository;
    private skuBaseIds: number[];

    constructor(skuBaseIds: number[]) {
        this.skuBaseIds = skuBaseIds;
        this.productRepository = diContainer.get(serviceNames.productRepository);
    }

    public execute = () => {
        this.productRepository.updateFavorites(this.skuBaseIds);
    };
}
